import { inject, Injectable } from "@angular/core";

import { timer } from "rxjs";

import { GlobalService } from "@shared/services";
import { CustomWindow } from "@shared/models";

declare let window: CustomWindow;

@Injectable({
  providedIn: "root",
})
export class NavbarService {
  globalService = inject(GlobalService);

  init(): void {
    timer(0, 1000).subscribe(() => {
      if (window.userFontSize) {
        this.globalService.isApaApp.set(true);
        switch (window.userFontSize) {
          case "small":
            this.globalService.navbarHeight.set(52);
            break;
          case "medium":
            this.globalService.navbarHeight.set(64);
            break;
          case "large":
            this.globalService.navbarHeight.set(72);
            break;
          default:
            this.globalService.navbarHeight.set(52);
        }
      }
    });
  }
}
